import { isMac, isIos, isAndroid } from 'helpers/DesktopHelpers'
import { hasFeatureFlag as organizationHasFeatureFlag } from 'data/organizations/selectors'
import { hasAbFlag as userHasFeatureFlag } from 'data/users/selectors'
import { hasFeatureFlag as userPrefsHasFeatureFlag } from 'data/userPreferences/selectors'

export const getConfig = ({ config }) => config
export const getApiEndpoint = ({ config }) => {
  if (config.isProduction) {
    return config.apiEndpoint
  }

  if (config.apiEndpoint.includes('http')) {
    return config.apiEndpoint
  }

  const { protocol, hostname } = window.location
  return `${protocol}//${hostname}:8000${config.apiEndpoint}`
}

export const getAppDomain = ({ config }) => config.appDomain
export const getCollabEndpoint = ({ config }) => config.collabEndpoint
export const getCookieDomain = ({ config }) => config.cookieDomain
export const getOrganizationDomain = ({ config }) => config.organizationDomain
export const getBoardingAppRoot = ({ config }) => config.boardingAppRoot
export const getSearchApplicationId = ({ config }) => config.searchApplicationId
export const getSearchToken = ({ config }) => config.searchToken
export const getIframelyApiKey = ({ config }) => config.iframelyApiKey
export const getStripePublicApiKey = ({ config }) => config.stripePublicApiKey
export const getGoogleProjectId = ({ config }) => config.googleProjectId
export const getGoogleApiKey = ({ config }) => config.googleApiKey
export const getSlackAppSliteClientId = ({ config }) =>
  config.slackAppSliteClientId

export const getDesktopDownloadUrl = state => {
  if (isIos()) {
    return 'https://itunes.apple.com/app/slite/id1342934691?ls=1&amp;mt=8'
  }

  if (isAndroid()) {
    return 'https://play.google.com/store/apps/details?id=com.slite.mobile'
  }

  const apiEndpoint = getApiEndpoint(state)
  const platform = isMac() ? 'mac' : 'win'
  return apiEndpoint
    ? `${apiEndpoint}/desktop/download?platform=${platform}`
    : null
}

export const hasFlag = (state, flag) => {
  return (
    organizationHasFeatureFlag(state, flag) ||
    userHasFeatureFlag(state, flag) ||
    userPrefsHasFeatureFlag(state, flag)
  )
}
